import gameIndex from '../../pages/game'

const GameRoute = [
  {
    path: '/game',
    name: 'game',
    component: gameIndex
  }
]

export default GameRoute



// WEBPACK FOOTER //
// ./src/router/game/index.js